import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { AuthErrorSummary } from "@/components/AuthFeedback";
import { CustomButton } from "@/components/Button";
import { useSendPasswordResetLink } from "@/hooks/useResetPassword";

import { SettingItemsProps } from "../../SettingsPage";
import { SettingsDestination, SettingsHelper, SettingsSuccessMark, useSettingsContentStyles } from "../SettingsContent";

export const ResetPassword: React.FC<SettingItemsProps> = ({ user, onBack }) => {
  const classes = useSettingsContentStyles();
  const { sendPasswordResetLink, loading, error, sentEmail } = useSendPasswordResetLink();
  const complete = sentEmail !== null;

  return (
    <>
      <Box className={classes.stack}>
        {complete && <SettingsSuccessMark />}
        <Box>
          <Typography component="h2" className={classes.heading}>
            {complete ? "再設定のリンクを送信しました" : "パスワードを再設定します"}
          </Typography>
          <Box mt={1}>
            <Typography className={classes.description}>
              {complete
                ? "メールのリンクを開いて、新しいパスワードを設定してください。"
                : "登録しているメールアドレスに、再設定のリンクを送ります。"}
            </Typography>
          </Box>
        </Box>
        <SettingsDestination label="送り先" value={complete ? sentEmail : user.email} />
        {complete ? (
          <Box className={classes.note}>
            <Typography className={classes.noteHeading}>届かないときは</Typography>
            <Typography className={classes.caption}>迷惑メールのフォルダをご確認ください。</Typography>
            <Typography className={classes.caption}>リンクは送信から60分で使えなくなります。</Typography>
          </Box>
        ) : (
          <SettingsHelper>
            Apple や Google で登録した方には、パスワードがありません。これまでと同じ方法でログインしてください。
          </SettingsHelper>
        )}
      </Box>
      <Box className={classes.actions}>
        <AuthErrorSummary message={error} />
        {complete ? (
          <CustomButton type="button" tone="outline" buttonSize="L" onClick={onBack}>
            設定に戻る
          </CustomButton>
        ) : (
          <CustomButton
            type="button"
            buttonSize="L"
            disabled={loading || !user.email}
            onClick={() => sendPasswordResetLink({ email: user.email })}
          >
            {loading ? "送信しています…" : "再設定のリンクを送る"}
          </CustomButton>
        )}
      </Box>
    </>
  );
};
